var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-50 flex items-center justify-center bg-white space-x-3",class:{
    'fixed w-screen h-screen': !_vm.isNested,
    'absolute left-0 top-0 w-full h-full': _vm.isNested,
  }},[_c('div',{staticClass:"w-4 h-4 bg-core rounded-full animate-bounce"}),_c('div',{staticClass:"animation-delay-75 w-4 h-4 bg-core rounded-full animate-bounce"}),_c('div',{staticClass:"animation-delay-150 w-4 h-4 bg-core rounded-full animate-bounce"})])}
var staticRenderFns = []

export { render, staticRenderFns }